import script from "./DetailedData.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedData.vue?vue&type=script&setup=true&lang=js"

import "./DetailedData.vue?vue&type=style&index=0&id=0bb6bffb&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb6bffb"]])

export default __exports__